import { Cell, Pie, PieChart } from 'recharts'

const ScoutdeckDatabase = () => {
    const chartData = [
        { position: 'Aanvallers', players: 34722, color: '#3778FA' },
        { position: 'Middenvelders', players: 76798, color: '#FCA601' },
        { position: 'Verdedigers', players: 29642, color: '#2ED452' },
        { position: 'Doelmannen', players: 13168, color: '#F64E4C' },
    ];

    const totalPlayers = chartData.reduce((acc, item) => acc + item.players, 0);

    return (
    <div className='bg-foreground/10 rounded-lg p-4 flex flex-col gap-4'>
        <p className='uppercase text-foreground/50 font-medium text-sm'>Scoutdeck database</p>

        <div className='grid grid-cols-2 gap-4'>
            <div className='relative w-[120px] h-[120px]'>
                <PieChart width={120} height={120}>
                    <Pie
                        data={chartData}
                        dataKey="players"
                        nameKey="position"
                        cx="50%"
                        cy="50%"
                        innerRadius={40}
                        outerRadius={60}
                        paddingAngle={3}
                    >
                        {chartData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} stroke="none"/>
                        ))}
                    </Pie>
                </PieChart>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
                    <p className='text-foreground font-semibold text-sm'>{totalPlayers.toLocaleString()}</p>
                    <p className='text-foreground/50 text-xs'>Spelers</p>
                </div>
            </div>

            <div className='flex flex-col justify-evenly text-foreground text-sm gap-2'>
                {chartData.map(({ position, players, color }) => (
                    <div key={position} className='flex items-center justify-between gap-8 w-full'>
                        <div className='flex items-center gap-4'>
                            <div className='w-4 h-4 rounded-full border' style={{ borderColor: color }} />
                            <p className='uppercase text-foreground/50 font-medium text-sm'>{position}</p>
                        </div>
                        <p className='font-medium'>{players.toLocaleString()}</p>
                    </div>
                ))}
            </div>
        </div>
    </div>
    )
}

export default ScoutdeckDatabase